export default __webpack_public_path__ + "static/media/CNo.78-5.0435663a.jpg";